import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

const FacadeProps = {
	loading: PropTypes.bool,
	conceal: PropTypes.bool,
	animated: PropTypes.bool,
	avatar: PropTypes.bool,
	title: PropTypes.bool,
	rows: PropTypes.number,
	style: PropTypes.object,
	range: PropTypes.arrayOf(PropTypes.number),
	children: PropTypes.element,
};

const FacadeDefault = {
	loading: true,
	conceal: false,
	animated: false,
	avatar: false,
	title: true,
	rows: 5,
};

export const Facade = ({
	loading,
	conceal,
	animated,
	avatar,
	title,
	rows,
	range: [start = 100, end = 100] = [],
	style,
	children,
}) => {
	const maxStart = Math.max(30, Math.min(start, 100));
	const maxEnd = Math.max(30, Math.min(end, 100));
	const startIsGreater = maxStart > maxEnd;
	const tempRange = Math.abs(maxEnd - maxStart);
	const range = () => {
		const tempResult = tempRange * Math.random();

		return tempResult + (startIsGreater ? maxEnd : maxStart);
	};

	return loading ? (
		<div
			className={`facade${conceal ? ' conceal' : ''} ${
				animated ? ' animated' : ''
			}`}
			style={style}>
			{avatar && (
				<div className='facade-profile'>
					<div className='facade-avatar' />
				</div>
			)}
			<div className='facade-description'>
				{title && <div className='facade-title' />}
				{!!rows && (
					<ul>
						{new Array(rows).fill().map((v, index) => (
							<li
								key={index}
								style={{
									width: `${
										rows === index + 1 && rows !== 1 ? maxStart / 2 : range()
									}%`,
								}}></li>
						))}
					</ul>
				)}
			</div>
		</div>
	) : (
		children || null
	);
};

Facade.propTypes = FacadeProps;
Facade.defaultProps = FacadeDefault;
